import { useTranslation } from 'react-i18next';
import { IconButton, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import * as Styled from '../styled';

export const Header = ({ closeAction }: { closeAction: () => void }) => {
  const { t } = useTranslation();

  return (
    <Styled.Header>
      <Typography variant="h6">{t('SubstituteWorker.popover')}</Typography>

      <IconButton onClick={closeAction}>
        <CloseIcon />
      </IconButton>
    </Styled.Header>
  );
};
